/*!
    * @product/scmp-sdk 1.1.8
    * built by undefined
  */
import{p as r}from"./chunk-BXSKAUIH.js";import n from"axios";var c=t=>({createUser:e=>n.post(`${t}/email/login`,{...e,create:1,flow:1,newsletterSubscribe:1},{headers:{"Content-Type":"application/json"},withCredentials:!0})});import{useEventListener as i}from"@react-hookz/web";import{useState as s}from"react";function f(){let[t,o]=s();return i(r(),"blur",()=>{var e;typeof window>"u"||o((e=document)===null||e===void 0?void 0:e.activeElement)}),{activeElement:t}}export{c as a,f as b};
//# sourceMappingURL=chunk-XDVU3XVV.js.map
